export const ERROR_MESSAGES = {
  INACTIVITY_LOGOUT: 'You have been logged out due to inactivity.',
  DOMAIN_NOT_AUTHORIZED: 'The requested domain is not authorized to access this ADP instance.',
  GENERIC: 'There was a problem. Please try again.',
  GOOGLE_LOGIN_FAILED: 'Google login failed.',
  GOOGLE_REGISTER_FAILED: 'Google register failed.',
  LOCAL_ACCOUNTS_NOT_SUPPORTED:
    'Not supported for local network authentication flow. Please contact your customer admin.',
  DOMAIN_AUTH_CHECK_FAILED: 'Something went wrong checking the domain authorization.',
} as const;

export type ErrorKey = keyof typeof ERROR_MESSAGES;
